interface Props {
    label: string;
    isRequired?: boolean;
}

export default function LabelHead({ label, isRequired = false }: Props) {
    return (
        <label className="mb-1.5 block text-xs font-medium text-gray-800">
            {label}
            {isRequired && <span className="text-red-500"> *</span>}
        </label>
    )
}
